import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";

export interface DraggingLineIndicatorProps {
  offsetY: number;
}

export function DraggingLineIndicator({
  offsetY,
}: Readonly<DraggingLineIndicatorProps>) {
  const { classes } = useStyles();

  return (
    <Box className={classes.container} style={{ top: offsetY }}>
      <Box className={classes.line} />
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    position: "absolute",
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    pointerEvents: "none",
    zIndex: 10,
  },
  line: {
    flex: 1,
    height: 2,
    backgroundColor: theme.palette.blue.main,
    borderRadius: 1,
  },
}));
